import { render, staticRenderFns } from "./ExpiredToken.vue?vue&type=template&id=514d9c7a&"
import script from "./ExpiredToken.vue?vue&type=script&lang=js&"
export * from "./ExpiredToken.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredToken.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports